import React from 'react';
import { BrokerFaces, Devider, HeaderWrapper, HeaderText } from './style';
import { CHAT_EXPERIMENT_1_HEADER } from '../SmartChat/Constants';
export var Header = function () {
    return (React.createElement(HeaderWrapper, null,
        React.createElement(BrokerFaces, { src: 'https://lendicdn.net/327bd43fb6e1de7a0a3f44af5ad14156/71ccb7a35a452ea8153b6d920f9f190e/images/lendi.png', alt: "Friendly broker image" }),
        React.createElement(HeaderText, null, CHAT_EXPERIMENT_1_HEADER),
        React.createElement(Devider, null)));
};
//# sourceMappingURL=Header.js.map